import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import lock from '../../assets/lock-480x480.png';
import ToolTips from "../Shared/ToolTips";
import whiteStar from '../../assets/icons/StarIconInUse.png';

class Unit extends Component {
    render() {
        const {unit} = this.props;
        let thumbnail =  unit.thumbnail_alt === null ? unit.thumbnail : unit.thumbnail_alt;
        return (
            <div className="campaign-content">
                <Link to={`${unit.unit_type}/${unit.id}`}>
                    <div className="campaign-content-wrapper">
                        <div className="tool-wrapper">
                            <div className="campaign-image-container" style={{backgroundImage: `url(${thumbnail})`}}>
                                {unit.unit_type === 'mock' && unit.animated === "true" ?  <span className="mocked-icon mocked-icon-btm-left"> </span> 
                                : unit.unit_type === 'live' ? <span className="live-icon mocked-icon-btm-left"></span> 
                                : <span className="mock-icon mocked-icon-btm-left"></span>}
                            </div>
                            {unit.favorite_id !== null ?
                                (<ToolTips content="Best in Class" data="bic">
                                  <span className="example-emoji" role="img" aria-label="cowboy emoji">
                                    
                                                                                                <img src={whiteStar} className="grey-star" alt="grey-star" style={{width: "24px", height: "24px", marginTop: "1px"}}/>
                                  </span>
                                </ToolTips>) : ""}
                        </div>
                    </div>
                </Link>
                <div className="campaign-entry-info">
                    <Link to={`brand/${unit.brand_id}`}><div className="campaign-name">{unit.campaign.hide_brand === 1 ?  <span id="lock-container"><ToolTips content="Hidden Brand" data="hb"><img src={lock} alt="brand is hidden"/></ToolTips></span> : ""} {unit.campaign.brand}</div></Link>
                    <p>{unit.creative_type}</p>
                </div>
            </div>
        )
    }
}

export default Unit;
